<template>
  <div id="wdbm" class="container">
    <div class="header">
      <div class="item">
        <div class="item-left">
          <img :src="courseDetails.Pic" />
        </div>
        <div class="item-right">
          <div class="item-content">
            <span class="title">{{courseDetails.Name}}</span>
            <span>
              报名企业：{{enterprise.Name}}
            </span>
            <span v-if="model.IsPackageOrder != null">
              套餐订单：{{model.IsPackageOrder == 1 ? '是' : '否'}}
            </span>
          </div>
          <div class="item-fooler">
            <span class="price">￥{{totalPrice}}</span>
            <span>
              报名人次：{{totalEmployeeCount}} 人次
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="content" id="content">
      <div class="box">
        <div class="title">
        </div>
        <el-table class="main" :data="courseJobs">
          <el-table-column prop="Name" label="岗位">
          </el-table-column>
          <el-table-column label="单价" width="280">
            <template slot-scope="scope">
              ￥{{scope.row.Price}}
            </template>
          </el-table-column>
          <el-table-column prop="EmployeeCount" label="报名人数" width="280">
          </el-table-column>
          <el-table-column label="小计" width="180">
            <template slot-scope="scope">
              ￥{{scope.row.SubTotalPrice}}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="box" v-for="item in courseJobs" :key="item.JobId">
        <div class="title">
          <span>{{item.Name}}</span>
        </div>
        <el-table v-if="model.CourseId == 5" class="table-xueyuan" :data="item.Employees">
          <el-table-column label="" width="100">
            <template slot-scope="scope">
              <div class="pic">
                <k-btn-img :slides="scope.row" style="width: 55px;height:78px">
                  <template slot="img" slot-scope="scope1">
                    <img style="width: 55px;height:100%" :data-original='scope1.item.Pic' :id="'img_avatar_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.Pic" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('img_avatar_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="208px">
            <template slot="header">
              <div class="custom-header">
                <div>姓名 | 性别</div>
                <div>身份证号</div>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="item">
                <div>
                  <span style="color: #333333;font-weight: 600;">{{scope.row.Name}}</span>
                  <span>{{scope.row.Sex==0?'男':'女'}}</span>
                </div>
                <div>
                  <span>{{scope.row.IdNumber}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="210px">
            <template slot="header">
              <div class="custom-header">
                <div>所学专业 | 学历</div>
                <div>岗位工作年限</div>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="item">
                <div>
                  <span :title="scope.row.Major">{{scope.row.Major}}</span>
                  <span>|</span>
                  <span :title="scope.row.EmployeeDegree" style="width:32px;white-space:nowrap;overflow:hidden; display: inline-flex;">{{scope.row.EmployeeDegree}}</span>
                </div>
                <div>
                  <span>{{scope.row.WorkYear ? scope.row.WorkYear + ' 年' : ''}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot="header">
              <div class="custom-header">
                <div>一寸照 | 学历证明 | 工作年限证明</div>
                <div>身份证国徽面 | 身份证人像面</div>
              </div>
            </template>
            <template slot-scope="scope">
              <div class="item item-imgs">

                <k-btn-img v-if="scope.row.PicZp" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicZp' :id="'file_zp_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicZp == null ? null : scope1.item.PicZp+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_zp_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicXlzs" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicXlzs' :id="'file_xlzm_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicXlzs == null ? null: scope1.item.PicXlzs + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_xlzm_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicGzzm" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicGzzm' :id="'file_gzzm_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicGzzm == null ? null : scope1.item.PicGzzm+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_gzzm_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicSfzfm" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicSfzfm' :id="'file_sfzfm_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicSfzfm == null ? null : scope1.item.PicSfzfm+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_sfzfm_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicSfzzm" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicSfzzm' :id="'file_sfzzm_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicSfzzm == null ? null : scope1.item.PicSfzzm+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_sfzzm_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-table v-else class="table-xueyuan" :data="item.Employees">
          <el-table-column label="" width="100">
            <template slot-scope="scope">
              <div class="pic">
                <k-btn-img :slides="scope.row" style="width: 55px;height:78px">
                  <template slot="img" slot-scope="scope1">
                    <img style="width: 55px;height:100%" :data-original='scope1.item.Pic' :id="'img_avatar_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.Pic" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('img_avatar_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="姓名/性别/身份证号" width="208px">
            <template slot-scope="scope">
              <div class="item">
                <div>
                  <span style="color: #333333;font-weight: 600;">{{scope.row.Name}}</span>
                  <span>{{scope.row.Sex==0?'男':'女'}}</span>
                </div>
                <div>
                  <span>{{scope.row.IdNumber}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="学历/专业/技术职称" width="210px">
            <template slot-scope="scope">
              <div class="item">
                <div>
                  <span :title="scope.row.EmployeeDegree" style="width:32px;white-space:nowrap;overflow:hidden; display: inline-flex;">{{scope.row.EmployeeDegree}}</span>
                  <span>|</span>
                  <span>{{scope.row.EmployeeTitle}}</span>
                </div>
                <div>
                  <span>{{scope.row.Major}}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="相关材料">
            <template slot-scope="scope">
              <div class="item item-imgs">
                <k-btn-img v-if="scope.row.PicCns" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicCns' :id="'img_cns_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicCns == null ? null : scope1.item.PicCns + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('img_cns_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicBmb" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicBmb' :id="'file_bmb_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicBmb == null ? null : scope1.item.PicBmb+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_bmb_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicXlzs" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicXlzs' :id="'file_xlzm_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicXlzs == null ? null: scope1.item.PicXlzs + '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_xlzm_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicZcjzszs" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicZcjzszs' :id="'file_jzs_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicZcjzszs == null ? null : scope1.item.PicZcjzszs+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_jzs_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicTjb" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicTjb' :id="'file_tjb_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicTjb == null ? null : scope1.item.PicTjb+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_tjb_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicGzzm" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicGzzm' :id="'file_gzzm_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicGzzm == null ? null : scope1.item.PicGzzm+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_gzzm_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicZyzs" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicZyzs' :id="'file_zyzs_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicZyzs == null ? null : scope1.item.PicZyzs+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_zyzs_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicSmpz" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicSmpz' :id="'file_smpz_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicSmpz == null ? null : scope1.item.PicSmpz+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_smpz_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicSfzzm" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicSfzzm' :id="'file_sfzzm_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicSfzzm == null ? null : scope1.item.PicSfzzm+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_sfzzm_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicSfzfm" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicSfzfm' :id="'file_sfzfm_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicSfzfm == null ? null : scope1.item.PicSfzfm+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_sfzfm_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicZp" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicZp' :id="'file_zp_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicZp == null ? null : scope1.item.PicZp+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_zp_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicHgz" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicHgz' :id="'file_hgz_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicHgz == null ? null : scope1.item.PicHgz+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_hgz_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicAkz" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicAkz' :id="'file_akz_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicAkz == null ? null : scope1.item.PicAkz+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_akz_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicCzz" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicCzz' :id="'file_czz_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicCzz == null ? null : scope1.item.PicCzz+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_czz_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <k-btn-img v-if="scope.row.PicSqb" :slides="scope.row">
                  <template slot="img" slot-scope="scope1">
                    <img :data-original='scope1.item.PicSqb' :id="'file_sqb_'+scope1.item.EmployeeId+'_'+item.JobId" :src="scope1.item.PicSqb == null ? null : scope1.item.PicSqb+ '?imageView2/1/w/136/h/48'" class="item-sc-img">
                  </template>
                  <template slot="btn" slot-scope="scope2">
                    <div @click="onClickImg('file_sqb_'+scope2.item.EmployeeId+'_'+item.JobId)">查看大图</div>
                  </template>
                </k-btn-img>

                <div class="text_div">
                  <div v-show="scope.row.CertificateCode">证书编号：{{scope.row.CertificateCode}}</div>
                  <div v-show="scope.row.CertificateDate">证书有效期截止日期：{{scope.row.CertificateDate}}</div>
                  <div v-show="scope.row.WorkYear">从业年限：{{scope.row.WorkYear}} 年</div>
                  <div v-show="scope.row.NativePlace">籍贯：{{scope.row.NativePlace}}</div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="box" v-if="projectName === 'SRJZY'">
        <div class="title"><span>开票信息</span></div>
        <div class="row" style="margin-top: 10px;">
          <div class="col-md-12">发票抬头：{{model.InvoiceTitle}}</div>
        </div>
        <div class="row" style="margin-top: 10px;">
          <div class="col-md-12">纳税人识别号：{{model.TaxpayerNumber}}</div>
        </div>
      </div>

      <div class="box" v-if="courseDetails.IsEnableLearnReceive == 1">
        <div class="title"><span>领取发票</span></div>
        <div class="row" style="margin-top: 10px;">
          <div class="col-md-2">领取方式：{{model.ReceiveMethodId == 1 ? '自取' : model.ReceiveMethodId == 2 ? '邮寄' : '电子邮箱'}}</div>
          <div class="col-md-2" v-if="model.ReceiveMethodId == 2">收件人：{{model.ReceivePerson}}</div>
          <div class="col-md-2" v-if="model.ReceiveMethodId == 2">手机号：{{model.ReceiveMobile}}</div>
        </div>
        <div class="row" style="margin-top: 10px;" v-if="model.ReceiveMethodId == 2">
          <div class="col-md-12">邮寄地址：{{model.ReceiveAddress}}</div>
        </div>
        <div class="row" style="margin-top: 10px;" v-if="model.ReceiveMethodId == 3">
          <div class="col-md-12">电子邮箱：{{model.ReceiveEmail}}</div>
          <div class="col-md-12" v-if="model.ReceiveMobile">手机号：{{model.ReceiveMobile}}</div>
        </div>
      </div>

      <div class="box" v-if="model.ProjectName">
        <div class="title"><span>项目信息</span></div>
        <div class="row" style="margin-top: 10px;">
          <div class="col-md-12">项目名称：{{model.ProjectName}}</div>
        </div>
        <div class="row" style="margin-top: 10px;">
          <div v-if="model.ProjectAddress" class="col-md-12">建设地址：{{model.ProjectAddress}}</div>
        </div>
        <div class="row" style="margin-top: 10px;">
          <div v-if="model.ProjectStarTime" class="col-md-2">开工时间：{{model.ProjectStarTime | dateformat('YYYY-MM-DD')}}</div>
          <div v-if="model.ProjectTimeLimit" class="col-md-6">工<span style="width:100px;"> </span>期：{{model.ProjectTimeLimit}}</div>
        </div>
      </div>

      <div class="box">
        <div class="title"><span>填写备注</span></div>
        <div class="row" style="margin-top: 10px;">
          <div class="col-md-12">{{model.Remark ? model.Remark : '无'}}</div>
        </div>
      </div>

      <div class="box">
        <div class="title"><span>上传附件</span></div>
        <div class="row" style="margin-top: 10px;">
          <div class="col-md-12 pics">
            {{(model.Pic1 || model.Pic2 || model.Pic3 || model.PicWts || model.PicCns || model.PicSght || model.PicDjb) ? '' : '无'}}
            <k-btn-img v-if="model.PicCns != null" :slides="[model.PicCns]" :src="model.PicCns">
              <template slot="img" slot-scope="scope1">
                <img :data-original='model.PicCns' id="pic_cns" :src="model.PicCns + '?imageView2/1/w/136/h/48'" class="item-sc-img">
              </template>
              <template slot="btn" slot-scope="scope2">
                <div @click="onClickImg('pic_cns')">查看大图</div>
              </template>
            </k-btn-img>
            <k-btn-img v-if="model.PicWts != null" :slides="[model.PicWts]" :src="model.PicWts">
              <template slot="img" slot-scope="scope1">
                <img :data-original='model.PicWts' id="pic_wts" :src="model.PicWts + '?imageView2/1/w/136/h/48'" class="item-sc-img">
              </template>
              <template slot="btn" slot-scope="scope2">
                <div @click="onClickImg('pic_wts')">查看大图</div>
              </template>
            </k-btn-img>
            <k-btn-img v-if="model.PicSght != null" :slides="[model.PicSght]" :src="model.PicSght">
              <template slot="img" slot-scope="scope1">
                <img :data-original='model.PicSght' id="pic_sght" :src="model.PicSght + '?imageView2/1/w/136/h/48'" class="item-sc-img">
              </template>
              <template slot="btn" slot-scope="scope2">
                <div @click="onClickImg('pic_sght')">查看大图</div>
              </template>
            </k-btn-img>
            <k-btn-img v-if="model.PicDjb != null" :slides="[model.PicDjb]" :src="model.PicDjb">
              <template slot="img" slot-scope="scope1">
                <img :data-original='model.PicDjb' id="pic_djb" :src="model.PicDjb + '?imageView2/1/w/136/h/48'" class="item-sc-img">
              </template>
              <template slot="btn" slot-scope="scope2">
                <div @click="onClickImg('pic_djb')">查看大图</div>
              </template>
            </k-btn-img>
            <k-btn-img v-if="model.Pic1 != null" :slides="[model.Pic1]" :src="model.Pic1">
              <template slot="img" slot-scope="scope1">
                <img :data-original='model.Pic1' id="img_pic1" :src="model.Pic1 + '?imageView2/1/w/136/h/48'" class="item-sc-img">
              </template>
              <template slot="btn" slot-scope="scope2">
                <div @click="onClickImg('img_pic1')">查看大图</div>
              </template>
            </k-btn-img>
            <k-btn-img v-if="model.Pic2 != null" :slides="[model.Pic2]" :src="model.Pic2">
              <template slot="img" slot-scope="scope1">
                <img :data-original='model.Pic2' id="img_pic2" :src="model.Pic2 + '?imageView2/1/w/136/h/48'" class="item-sc-img">
              </template>
              <template slot="btn" slot-scope="scope2">
                <div @click="onClickImg('img_pic2')">查看大图</div>
              </template>
            </k-btn-img>
            <k-btn-img v-if="model.Pic3 != null" :slides="[model.Pic3]" :src="model.Pic3">
              <template slot="img" slot-scope="scope1">
                <img :data-original='model.Pic3' id="img_pic3" :src="model.Pic3 + '?imageView2/1/w/136/h/48'" class="item-sc-img">
              </template>
              <template slot="btn" slot-scope="scope2">
                <div @click="onClickImg('img_pic3')">查看大图</div>
              </template>
            </k-btn-img>
          </div>
        </div>
      </div>
    </div>
    <div class="fooler">
      <el-button class="k-btn-default lg" @click="onCancel">返回修改</el-button>
      <el-button class="k-btn-primary lg" @click="onSubmit" :disabled="submitDisabled" :loading="submitDisabled">确认报名</el-button>
    </div>
    <el-dialog id='ncbdy-dialog' title="" :visible.sync="ncbdyDialogVisible" width="500px" :show-close='false' :close-on-click-modal='false' :before-close="onSubmitOk">
      <div class="box-dialog">
        <div class="box-title">提示</div>
        <div class="box-row" style="margin-top:32px">
          <div>恭喜您，报名成功！</div>
          <div>1. 为了方便报名必修课，待课程开通后，您可以在订单详情中导出必修课报名表及必修课报名材料，直接上传至必修课报名系统（<a href="//jx.zhujianpeixun.com" target="_blank">jx.zhujianpeixun.com</a>）即可。</div>
          <div>2. 待审核通过后平台会发送短信通知，转账缴费后请将缴费凭证发送至“南昌市培训中心缴费群（群号：522613867）”联系财务审核。</div>
        </div>
        <div class="box-row" style="margin-top:10px;text-align:right">
          <el-button class="el-button el-button--default el-button--small el-button--primary" @click="onSubmitOk">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog id="srjzy-dialog" title="" :visible.sync="srjzyDialogVisible" :before-close="onSubmitOk" :show-close='false' :close-on-click-modal='false'>
      <div class="box-dialog">
        <div class="box-title">报名成功</div>
        <div class="box-row" style="margin-top:32px">
          <div style="width: 498px;padding-right: 40px;font-size: 16px;">
            <p>恭喜您，报名成功！请截图此页面发送给贵公司财务进行缴费，缴费信息如下。您也可以使用支付宝、云闪付 App 扫描右侧二维码进行缴费。缴费时请备注企业简称及报名编号，缴费后请上传缴费凭证至平台。</p>
            <p>收款户名：<span>上饶市国控职业培训学校有限公司</span> <a href="javascript:void(0);" class="text-link copy-text" :data-clipboard-text="'收款户名：上饶市国控职业培训学校有限公司；收款帐号：159389010000033356；收款银行：上饶农村商业银行股份有限公司三清支行；报名编号：'+orderCode">点击此处复制</a></p>
            <p>收款帐号：<span>159389010000033356</span></p>
            <p>收款银行：<span>上饶农村商业银行股份有限公司三清支行</span></p>
            <p>报名编号：<span>{{orderCode}}</span></p>
            <!-- <p>注：转账时请备注企业简称及报名编号，缴费后请上传缴费凭证至平台。</p> -->
          </div>
          <div style="width:238px;display: flex; justify-content: center; align-items: center; flex-direction: column;">
            <img src="https://srsjzy-1253588055.cos.ap-shanghai.myqcloud.com/assets/fk_qrcode.jpg" style="width: 180px;">
            <div style="background-color: rgb(240,240,240); padding: 10px; color: #333; margin-top: 10px;">使用支付宝、云闪付扫一扫付款，付款说明输入企业简称和报名编号。</div>
          </div>
        </div>
        <div class="box-row" style="justify-content: end; margin-top: 16px;">
          <el-button class="el-button el-button--default el-button--small el-button--primary" @click="onSubmitOk">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog id='qrcode-dialog' title="" :visible.sync="qrCodeDialogVisible" width="400px" :show-close='false' :close-on-click-modal='false' :before-close="onSubmitOk">
      <div class="box-dialog">
        <!-- <div class="box-title">提示</div> -->
        <div style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
          <img :src="qrCodeUrl" style="width: 200px;">
          <div style="background-color: rgb(240,240,240); padding: 10px; color: #333; margin-top: 10px;">使用微信扫码二维码并关注我们，获取报名审核进度提醒。</div>
        </div>
        <div class="box-row" style="margin-top:10px;text-align:right">
          <el-button class="el-button el-button--default el-button--small el-button--primary" @click="onQrCodeDialogClose">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters, ProjectSettings } from '@/views/base/base.js'
import 'viewerjs/dist/viewer.css';
import Viewer from 'viewerjs';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

let viewer = null;

export default {
  name: 'kcbmsh-info',
  data() {
    return {
      totalPrice: 0,
      totalEmployeeCount: 0,
      courseJobs: [],
      model: {
        CourseId: null,
        LearnId: null,
        IsPackageOrder: null,
        ReceiveMethodId: null,
        ReceivePerson: '',
        ReceiveMobile: '',
        ReceiveAddress: '',
        ReceiveEmail: '',
        JobEmployees: [],
        Remark: '',
        Pic1: null,
        Pic2: null,
        Pic3: null,
        PicWts: null,
        PicCns: null,
        PicDjb: null,
        ProjectName: null,
        ProjectAddress: null,
        ProjectStarTime: null,
        ProjectTimeLimit: null,
        PicSght: null,
        InvoiceTitle: null,
        TaxpayerNumber: null
      },
      submitDisabled: false,
      projectName: ProjectSettings.Name,
      enableLearnTmpQrCode: ProjectSettings.EnableLearnTmpQrCode,
      ncbdyDialogVisible: false,
      srjzyDialogVisible: false,
      orderCode: '',
      qrCodeDialogVisible: false,
      qrCodeUrl: '',
      learnId: null
    }
  },
  components: {
    VueCropper
  },
  computed: {
    ...mapGetters({
      enterprise: 'getMyEnterprise',
      courseDetails: 'getCourseDetails'
    })
  },

  filters: {
    dateformat(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
      if (dataStr === null) {
        return '';
      }
      return moment(dataStr).format(pattern)
    }
  },
  mounted() {
    let that = this;
    viewer = null;
    this.model.CourseId = this.$route.query.courseId;
    if (this.$route.query.learnId) {
      this.model.LearnId = this.$route.query.learnId;
    }

    let model = this.$store.getters.getEnroll;
    if (model.CourseId && model.CourseId === that.model.CourseId) {
      this.model.IsPackageOrder = model.IsPackageOrder;
      that.model.ReceiveMethodId = model.ReceiveMethodId;
      that.model.ReceivePerson = model.ReceivePerson;
      that.model.ReceiveMobile = model.ReceiveMobile;
      that.model.ReceiveAddress = model.ReceiveAddress;
      that.model.ReceiveEmail = model.ReceiveEmail;
      that.model.Remark = model.Remark;
      that.model.Pic1 = model.Pic1;
      that.model.Pic2 = model.Pic2;
      that.model.Pic3 = model.Pic3;
      that.model.PicWts = model.PicWts;
      that.model.PicCns = model.PicCns;
      that.model.PicDjb = model.PicDjb;
      that.model.ProjectName = model.ProjectName;
      that.model.ProjectAddress = model.ProjectAddress;
      that.model.ProjectStarTime = model.ProjectStarTime;
      that.model.ProjectTimeLimit = model.ProjectTimeLimit;
      that.model.PicSght = model.PicSght;
      that.model.InvoiceTitle = model.InvoiceTitle;
      that.model.TaxpayerNumber = model.TaxpayerNumber;
    }

    this.$store.dispatch('getMyEnterprise');
    this.$store.dispatch('getCourseDetails', { Id: this.model.CourseId });
    this.$store.dispatch('getCourseOpenJobs', { courseId: this.model.CourseId }).then(res => {
      let courseJobs = res.Data;
      let jobEmployees = _.cloneDeep(this.$store.getters.getEnrollStudent);
      let newJobEmployees = [];

      // 去掉重复学员
      _.forEach(jobEmployees, item => {
        // 有时候会是字符串
        item.JobId = Number(item.JobId);

        let employees = _.find(newJobEmployees, { 'JobId': item.JobId });
        if (!employees) {
          newJobEmployees.push(item);
          employees = item.Employees;
        } else {
          employees = _.concat(employees, item.Employees);
        }

        employees = _.uniqBy(employees, 'EmployeeId');
      });

      // 去掉没有学员报名的职业
      newJobEmployees = _.filter(newJobEmployees, item => {
        return item.Employees.length > 0;
      });

      // 保存需要提交的数据
      this.model.JobEmployees = newJobEmployees;

      _.forEach(courseJobs, job => {
        _.forEach(newJobEmployees, item => {
          if (job.Id === item.JobId) {
            job.Employees = item.Employees;

            job.EmployeeCount = job.Employees.length;
            job.SubTotalPrice = job.Price * job.EmployeeCount;

            that.totalEmployeeCount += job.EmployeeCount;
            that.totalPrice += job.SubTotalPrice;
          }
        });
      });

      that.courseJobs = _.filter(courseJobs, t => {
        return t.EmployeeCount > 0
      });
    });
  },

  methods: {
    onCancel() {
      this.$router.push({ name: 'courseEnroll', query: { CourseId: this.model.CourseId, LearnId: this.$route.query.learnId } });
    },
    onSubmit() {
      let that = this;
      that.submitDisabled = true;
      that.$store.dispatch('postLearnRegistration', that.model).then((response) => {
        if (response.MsgCode === 0) {
          let data = response.Data;
          that.learnId = data.Id;

          // 判断该课程是否开启在线支付
          if (data.LearnApproveStateId === -3) {
            that.$router.push({ name: 'courseEnrollPay', query: { learnId: that.learnId } });
          } else {
            if (that.projectName === 'NCJZJY' && Number(that.model.CourseId) === 5) {
              that.ncbdyDialogVisible = true;
            } else if (that.projectName === 'SRJZY') {
              that.srjzyDialogVisible = true;
              that.orderCode = response.Data.OrderCode;
            } else {
              let msg = '恭喜您，报名成功！ 待课程报名审核通过后平台会发送短信通知，转账缴费后请将缴费凭证上传至平台“我的课程报名 > 上传缴费凭证”。';
              if (that.projectName === 'JASJZY') {
                msg = '恭喜，您已成功报名，请于当天完成缴费并在平台我的课程报名中上传缴费凭证。'
              }

              that.$alert(msg, '提示', {
                confirmButtonText: '确定',
                showClose: false,
                callback: action => {
                  that.onSubmitOk();
                }
              });
            }
          }
        } else {
          that.$alert(response.Message, '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        }
        that.submitDisabled = false
      });
    },
    onSubmitOk() {
      let that = this;
      if (this.enableLearnTmpQrCode === true) {
        this.$store.dispatch('getWeiXinTmpQrCode', { learnId: that.learnId }).then(res => {
          if (res.MsgCode === 0) {
            let data = res.Data;
            that.qrCodeUrl = data.Url;
            that.qrCodeDialogVisible = true;
          } else {
            that.$alert(res.Message, '提示', {
              confirmButtonText: '确定',
              callback: action => {
              }
            });
          }
        });
      } else {
        this.$router.push({ name: 'qyglwdbm' });
      }
    },
    onQrCodeDialogClose() {
      this.qrCodeDialogVisible = false;
      this.$router.push({ name: 'qyglwdbm' });
    },
    onClickImg(id) {
      if (viewer == null) {
        // 初始化 viewer.js
        viewer = new Viewer(document.getElementById('content'), {
          url: 'data-original',
          filter: function (image) {
            if ($(image).prop('src') !== '') {
              return true;
            }
          }
        });
      }
      $('#' + id).click();
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/list.scss';
.container {
  display: flex;
  flex-direction: column;
  .header {
    margin-top: 25px;
    .item {
      overflow: hidden;
      display: flex;
      flex-direction: row;
      background-color: #f9f9f9;
      border-radius: 4px;
      position: relative;
      .item-left {
        height: 230px;
        width: 280px;
        img {
          max-width: 100%;
          height: 100%;
        }
      }
      .item-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-left: 28px;
        margin-right: 20px;
        .item-content {
          display: flex;
          flex-direction: column;
          flex: 2;
          // width: 65%;
          color: #777;
          .title {
            font-size: 24px;
            color: #2f2f2f;
            margin-top: 16px;
            margin-bottom: 16px;
            font-weight: 700;
          }
          .no {
            color: #777;
            font-size: 16px;
            margin-top: 18px;
            margin-left: 20px;
            font-weight: 400;
          }
          span {
            font-size: 16px;
            margin-bottom: 10px;
          }
          .span-href:hover {
            color: #16cfd0;
            cursor: pointer;
          }
        }
        .item-fooler {
          display: flex;
          justify-content: space-between;
          flex: 1;
          align-items: center;
          .price {
            font-size: 30px;
            color: #16cfd0;
          }
          span {
            font-size: 16px;
          }
        }
      }
      .item-status-label {
        position: absolute;
        right: -60px;
        top: -60px;
        width: 120px;
        height: 120px;
        background-color: #ff6715;
        text-align: center;
        transform: rotate(45deg);
        box-shadow: 0 1px 1px #ccc;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        i {
          color: #fff;
        }
        span {
          margin-bottom: 8px;
          color: #fff;
        }
        &.tg {
          background-color: #16cfd0;
        }
        &.jj {
          background-color: #a8a8a8;
        }
        &.shz {
          background-color: #ff6715;
        }
      }
    }
  }
  .content {
    .box {
      display: flex;
      flex-direction: column;
      .title {
        margin-top: 70px;
        span {
          font-size: 30px;
          float: left;
          color: #333;
          font-weight: 600;
        }
      }
      .pics {
        display: flex;
        > div {
          margin-right: 20px;
        }
      }
      .main {
        width: 100%;
        margin-top: 40px;
      }
      .table-xueyuan {
        margin-top: 35px;
        .cell-btn {
          display: flex;
          align-items: center;
          color: #16cfd0;
          cursor: pointer;
        }
      }
    }
    .box-process {
      display: flex;
      flex-direction: column;
      > .title {
        margin-top: 70px;
        font-weight: 600;
        span {
          font-size: 30px;
          float: left;
          color: #333;
        }
      }
      .main {
        width: 100%;
        margin-top: 30px;
        border: 1px solid #eaeaea;
        > .row {
          line-height: 40px;
          padding: 30px 40px;
          margin: 0px;
          & + .row {
            border-top: 1px solid #eaeaea !important;
          }
          .span-no {
            font-size: 70px;
            margin: 20px 0px 0px 0px;
            color: #eaeaea;
          }
          .content-sh {
            display: flex;
            flex-direction: column;
            font-size: 16px;
            color: #777777;
            flex: 1;
            .title {
              font-size: 24px;
              color: #333333;
              line-height: 46px;
              display: flex;
              align-items: center;
              font-weight: 600;
              .tag {
                padding: 0 4px;
                background-color: #ff6715;
                border-radius: 4px;
                color: #fff;
                font-size: 12px;
                height: 20px;
                line-height: 20px;
                display: inline-block;
                margin-left: 10px;
              }
            }
            .row {
              display: flex;
              align-items: center;
              justify-content: space-between;
              div {
                width: 190px;
                & + div {
                  flex: 1;
                }
              }
            }
            .box-kpxx {
              margin-top: 32px;
              .box-title {
                font-size: 24px;
                color: #333333;
              }
              .box-row {
                display: flex;
                margin-top: 8px;
                .el-input {
                  margin-left: 16px;
                }
                .el-checkbox {
                  color: #777;
                  font-size: 16px;
                  font-weight: 400;
                }
              }
            }
          }
        }
      }
    }
    .jfpz-file {
      display: flex;
      align-items: center;
      margin: 20px 0 0 0;
    }
    .jfpz-file-btn {
      justify-content: center;
      display: flex;
      border: 1px solid #dedede;
      color: #dedede;
      cursor: pointer;
      border-radius: 5px;
      width: 400px;
      height: 200px;
      align-items: center;
      flex-direction: column;
    }
    .jfpz-img {
      width: 400px;
      height: 200px;
      margin: 20px 0 0 0;
    }
    .jfpz-sc-img {
      width: 400px;
      height: 200px;
      -o-object-fit: cover;
      object-fit: cover;
      border: 1px dashed #dedede;
      cursor: pointer;
      border-radius: 5px;
    }
    .item-sc-btn {
      display: flex;
      border: 1px solid #dedede;
      color: #dedede;
      cursor: pointer;
      border-radius: 5px;
      width: 136px;
      height: 48px;
      align-items: center;

      div {
        justify-content: center;
        align-items: center;
        display: flex;
      }
      div:first-child {
        width: 32px;
        height: 48px;
        border-right: 1px solid #dedede;
        font-size: 24px;
      }
      div:nth-child(2) {
        width: 104px;
      }
      &.isActive {
        border: 1px solid #ff6715;
        color: #ff6715;
        div:first-child {
          border-right: 1px solid #ff6715;
        }
      }
    }
    .item-sc-img {
      width: 136px;
      height: 48px;
      object-fit: cover;
      border: 1px dashed #dedede;
      cursor: pointer;
      border-radius: 5px;
    }
    .btn-img {
      width: 136px;
      height: 48px;
      display: flex;
      align-items: center;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 5px;
      position: absolute;
      top: 0;
      div {
        flex: 1;
        font-size: 12px;
        justify-content: center;
        display: flex;
        cursor: pointer;
      }
    }
    .item-imgs {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: -10px;
      > div {
        margin-right: 20px;
        margin: 0 20px 10px 0;
        .span_error {
          color: #ff6715;
          font-size: 14px;
          position: absolute;
          margin-top: 48px;
        }
      }
      .text_div {
        font-size: 14px;
        line-height: 23px;
      }
    }
  }
  .fooler {
    margin-top: 60px;
    display: flex;
    justify-content: flex-end;
    button + button {
      margin-left: 30px;
    }
  }
  .box-sczp {
    .box-sczp-content {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      .avatar-uploader {
        width: 160px;
        height: 200px;
        margin-bottom: 8px;
        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 100%;
          height: 100%;
          line-height: 200px;
          text-align: center;
        }
        .avatar {
          width: 160px;
          height: 200px;
          display: block;
          position: relative;
          z-index: 2;
        }
        .avatar-title {
          margin-top: -80px;
          display: flex;
          justify-content: center;
          font-size: 14px;
          color: #a8a8a8;
        }
        img {
          border: 1px solid #dedede;
          border-radius: 6px;
          cursor: pointer;
        }
        i {
          border: 1px solid #dedede;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          &:hover {
            border-color: #409eff;
          }
        }
      }
      .cropper-content {
        text-align: center;
        max-width: 400px;
        max-height: 300px;
        position: relative;
        div:first-child {
          height: 300px;
          overflow: hidden;
        }
        .cxsc-btn {
          position: absolute;
          top: 130px;
          left: 128px;
          font-size: 24px;
          color: #fff;
        }
      }
      .demo-img {
        width: 160px;
        height: 200px;
        border: 1px dashed #dedede;
        border-radius: 0;
      }
    }
    .box-sczp-desc {
      width: 408px;
      text-align: left;
      margin-top: 20px;
      font-size: 16px;
      line-height: 24px;
      color: #ff6715;
    }
    .box-sczp-fooler {
      text-align: right;
    }
  }
}

.el-form-item {
  margin-bottom: 0px;
}
#ncbdy-dialog .box-dialog {
  .box-title {
    font-size: 24px;
    color: #333333;
    position: absolute;
    top: 30px;
    padding-left: 12px;
  }
  .box-row {
    padding: 0 12px;
    font-size: 16px;
    div {
      margin-bottom: 12px;
      a {
        color: #409eff;
      }
    }
  }
}

#srjzy-dialog {
  .box-dialog {
    .box-title {
      font-size: 24px;
      color: #333333;
      position: absolute;
      top: 30px;
      padding-left: 12px;
    }
    .box-row {
      display: flex;
      padding: 0 12px;
      p {
        text-indent: 32px;
        span {
          color: #ff6715;
        }
      }
    }
  }
}
</style>
<style>
#wdbm .el-table__header thead th > div {
  color: #333;
  font-weight: 600;
}

#wdbm .el-table th,
#wdbm .el-table td {
  padding: 18px 0;
}

#wdbm .el-table th.is-leaf {
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
</style>
<style scoped>
.el-table >>> .el-table__row:hover,
.el-table >>> .el-table__row:focus {
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.16);
}

.el-table >>> .el-table__row {
  transition: 0.3s all ease-in-out;
}
.el-form-item >>> .el-form-item__error {
  padding-top: 2px;
}
#wdbm >>> .el-radio-group + .el-form-item__error {
  margin-top: -10px;
  margin-left: 40px;
}
.el-input >>> input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #c0c4cc !important;
}
#ncbdy-dialog >>> .el-dialog {
  margin: 0 !important;
  width: 500px;
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#srjzy-dialog >>> .el-dialog {
  margin: 0 !important;
  width: 800px;
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#qrcode-dialog >>> .el-dialog {
  margin: 0 !important;
  width: 500px;
  position: absolute !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#srjzy-dialog >>> .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #ff6715;
  border-color: #ff6715;
}
#srjzy-dialog >>> .el-checkbox__inner {
  border: 1px solid #ff6715;
}
#srjzy-dialog >>> .el-checkbox__inner:hover {
  border-color: #ff6715;
}
</style>



// WEBPACK FOOTER //
// src/views/home/course_enroll_submit.vue